export function removeTrailingId(value: string): string {
  return value.replace(/\s*\([^)]*\)/, '')
}
